import { toasts } from '@ui/Toast/toasts'

export interface ToastAction {
  type: 'primary' | 'secondary' | 'destructive'
  /**
   * The title can either be a string or `Undo`.
   *
   * If the title is `Undo`, pressing the `Meta+z` keys while the tooltip is open
   * will call the `onClick` callback.
   */
  title: 'Undo' | (string & {})
  onClick?: () => void
}

export interface OpenToastState {
  open: true
  type: 'info' | 'error' | 'loading' | 'special'
  message: string
  duration?: number
  actions?: ToastAction[]
}

export interface ClosedToastState {
  open: false
}

export type ToastState = OpenToastState | ClosedToastState

export class ToastUiStore {
  private readonly legacyToastId = '__legacy_toast_id__'

  show = (state: Omit<OpenToastState, 'open' | 'type'>): void => {
    toasts.show(
      {
        type: 'info',
        message: state.message,
        actions: state.actions,
      },
      {
        id: this.legacyToastId,
        duration: state.duration,
      },
    )
  }

  showLoading = (message: string, actions?: ToastAction[]): void => {
    toasts.show(
      {
        type: 'loading',
        message,
        actions,
      },
      {
        id: this.legacyToastId,
      },
    )
  }

  showError = (
    error: unknown,
    options?: Pick<OpenToastState, 'actions' | 'duration'>,
  ): void => {
    const message = error instanceof Error ? error.message : String(error)

    toasts.show(
      {
        type: 'error',
        message,
        actions: options?.actions,
      },
      {
        id: this.legacyToastId,
        duration: options?.duration,
      },
    )
  }

  hide = (): void => {
    toasts.remove(this.legacyToastId)
  }
}
